import axiosCSRF from '../util/axiosCSRF';
import { OPENING_ACTIONS } from '../constants/actionTypes';
const { RECEIVE_OPENING, COPIED_OPENING } = OPENING_ACTIONS;

export class OpeningApi {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  show() {
    const openingSlug = window.location.pathname.replace('/openings/', '');

    axiosCSRF.get(`/api/v2/openings/${openingSlug}`)
      .then(response => {
        const { opening } = response.data;
        this.dispatch({ type: RECEIVE_OPENING, opening });
      }).catch(error => {
        console.error('Error:', error);
      });
  }

  create(opening) {
    axiosCSRF.post(`/api/v2/openings`, {id: opening.id})
      .then(response => {
        const { position } = response.data

        this.dispatch({ type: COPIED_OPENING });
        setTimeout(() => { window.location.href = `/analysis/${position.id}/edit` }, 3000);
      }).catch(error => {
        console.error('Error:', error);
      });
  }
}